import React from 'react';

import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { useWizard } from 'ui-components/components/wizard/context';

import { BackButton } from './back-button';
import { FundLaterButton } from './fund-later-button';
import { ModalFooterProgressBar } from './modal-footer-progress-bar/';
import { PrimaryActionButton } from './primary-action-button';
import style from './style.module.less';
import { useAddFundsContext } from '../../../../../pages/settings/payment-and-subscription/context/add-funds-context-provider';
import { messages } from '../../../../messages';
import { ADD_FUNDS_TAB } from '../../../../utilities/constants';
import { useWalletRegistrationFormContext } from '../../contexts/wallet-registration-form-context';
import { useWalletRegistrationModalContext } from '../../contexts/wallet-registration-modal-context';

/**
 * @param {object} props
 * @param {() => void} props.setWasTermsStepSuccessful
 * @returns {React.ReactElement}
 */
export const WalletModalFooter = ({ setWasTermsStepSuccessful }) => {
  const { submittingRegistration } = useWalletRegistrationFormContext();
  const { submitting } = useAddFundsContext();
  const { activeStep } = useWizard();
  const { shouldShowOldTermsTab } = useWalletRegistrationModalContext();
  const submitInProgress = submitting || submittingRegistration;
  const isAddFundsTab = activeStep?.stepId === ADD_FUNDS_TAB;

  // Show Fund Later button only in new flow on add funds tab
  const showFundLaterButton = isAddFundsTab && !shouldShowOldTermsTab;

  return (
    <div>
      {submitInProgress ? <ModalFooterProgressBar /> : null}
      <ModalFooter className={style['modal-footer']}>
        <div className={style['footer-left']}>{!isAddFundsTab && <BackButton disabled={submitInProgress} />}</div>
        <div className={style['footer-right']}>
          {showFundLaterButton ? (
            <FundLaterButton disabled={submitInProgress} />
          ) : (
            <ModalFooterCancelButton
              className={style.button}
              disabled={submitInProgress}
              text={isAddFundsTab ? messages.fundLater : undefined}
            />
          )}
          <PrimaryActionButton disabled={submitInProgress} setWasTermsStepSuccessful={setWasTermsStepSuccessful} />
        </div>
      </ModalFooter>
    </div>
  );
};
